module.exports = __webpack_public_path__ + "img/magento-code-review.9ac9a8c0.webp";